module.exports = new __parcel__URL__("shop_machines_cadet_dorms.46f8767e.png").toString();